import {Image, Text, TextInput, TouchableOpacity, View} from 'react-native';
import SubjectList from './components/SubjectList';
import {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  fetchBookVersions,
  fetchGrades,
  fetchPaperDetails,
  fetchPaperPreview,
  fetchPaperTypes,
  fetchSubjects,
  selectBookVersions,
  selectGrades,
  selectSubjects,
} from '../../../store/xueke';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../../components/Loading/GlobalLoading';
import {getUserInfo, selectUserInfo} from '../../../store/user';
import {
  GetPaperDetailParams,
  getXKWPapersGetForClassicPapers,
  getXKWPapersGetForEnrolmentPapers,
  PapersForPhaseTestingParams,
  PapersForPhaseTestingRes,
  PapersForPhaseTestingResItem,
  updateXkwInfo,
  UpdateXkwInfoParams,
} from '../../../API/mylearn';
import BasicInfo from './components/BasicInfo';
import {createStyles} from '../../../utils/createStyles';
import Buttons from './components/Buttons';
import {zhuanti} from './components/sceneType';
import TestList from './components/TestList';
import YearListModal from './components/yearsList';
import {useNavigation} from '@react-navigation/native';
import {provinceList} from './components/province';
import AreaListModal from './components/areaList';

const MyLearnBeikaoZhuanti = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const subjects = useAppSelector(selectSubjects);
  const userInfo = useAppSelector(selectUserInfo); // 用户信息
  const [currentSubjectId, setCurrentSubjectId] = useState(1);
  const [updateBasicInfoObjState, setUpdateBasicInfoObjState] = useState(true);
  const [basicInfoObj, setBasicInfoObj] = useState<UpdateXkwInfoParams>({});
  const [basicInfoName, setBasicInfoName] = useState('请选择教材版本');
  const [visible, setVisible] = useState(false);
  const grades = useAppSelector(selectGrades);
  const versions = useAppSelector(selectBookVersions);
  const [testList, setTestList] = useState<PapersForPhaseTestingResItem[]>([]); // 测试列表
  const [pageIndex, setPageIndex] = useState(1);
  const [yearListVisible, setYearListVisible] = useState(false);
  const [areaListVisible, setAreaListVisible] = useState(false);
  const [currentYear, setCurrentYear] = useState(0);
  const TestListRef = useRef(null);
  const [searchValue, setSearchValue] = useState('');
  // @ts-ignore
  const [listDta, setListData] = useState<PapersForPhaseTestingRes>({});
  const changeYear = (year: number) => {
    setCurrentYear(year);
  };
  const changeArea = (area: number) => {
    setArea(area);
  };
  const changeSubject = (id: number) => {
    setCurrentSubjectId(id);
  };

  const [senceType, setSenceType] = useState<Array<{name: string; id: string}>>(
    [
      {name: '全部', id: 'all'},
      ...zhuanti.type[
        userInfo.xkwStageId ? userInfo.xkwStageId : userInfo.studyPhase
      ],
    ],
  );
  const [currentSecneType, setCurrentSecneType] = useState<number | string>(
    'all',
  );
  const areaList = [
    ...provinceList.filter(item => {
      return item.parentId === 0 && ![810000, 710000, 820000].includes(item.id);
    }),
  ];
  const [area, setArea] = useState<number>(1);

  // 初始化基础信息
  const initBasicInfo = async () => {
    setUpdateBasicInfoObjState(true);
    showGlobalLoading({text: '加载中'});
    await dispatch(fetchPaperTypes()).unwrap(); // 获取所有类型
    await dispatch(fetchGrades()).unwrap(); // 获取所有年级
    dispatch(getUserInfo()) // 获取用户信息
      .unwrap()
      .then(res => {
        const grade_id = res.xkwGradeId
          ? res.xkwGradeId
          : res.grade
          ? res.grade
          : 0;
        const term = res.xkwTerm ? res.xkwTerm : 'LAST';
        dispatch(fetchSubjects(grade_id)) // 通过用户年级获取科目列表
          .unwrap()
          .then(async sub => {
            const subject_id = sub[0].id;
            const version_id = await getVersionId(grade_id, subject_id);
            setBasicInfoObj(prevBasicInfoObj => ({
              ...prevBasicInfoObj,
              grade_id: grade_id,
              term,
              version_id,
              subject_id,
            }));
            changeSubject(subject_id);
            setUpdateBasicInfoObjState(false);
            hideGlobalLoading();
            // });
          });
      });
  };
  const getVersionId = (grade_id: number, subject_id: number) => {
    return dispatch(
      fetchBookVersions({
        gradeId: grade_id,
        subjectId: subject_id,
      }),
    )
      .unwrap()
      .then(res => {
        const list = userInfo.xkwCoursesTextbookVersionsList;
        const version =
          list !== undefined &&
          list.find(
            item =>
              item.grade_id === grade_id && item.subject_id === subject_id,
          );
        if (version) {
          return version.version_id;
        } else {
          return res[0].id;
        }
      });
  };
  useEffect(() => {
    initBasicInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 获取列表
  const getList = async (clean?: boolean) => {
    showGlobalLoading({text: '加载中'});
    try {
      const p: PapersForPhaseTestingParams = {
        grade_id: basicInfoObj.grade_id,
        version_id: basicInfoObj.version_id,
        page_index: pageIndex,
        page_size: 20,
        area_id: area === 1 ? '' : area,
        practiceType: -1,
        subject_id: currentSubjectId,
        sceneType: currentSecneType,
        years: currentYear ? (currentYear === 9999 ? [] : [currentYear]) : [],
        title_keyword: clean ? '' : searchValue,
      };
      const res = await getXKWPapersGetForEnrolmentPapers(p);
      setListData(res.data);
      if (!res.data) {
        setTestList([]);
        return;
      }
      if (pageIndex === 1) {
        setTestList(res.data.items);
        return;
      } else {
        setTestList([...testList, ...res.data.items]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  const loadMore = () => {
    console.log('loadMore', listDta.total_size, testList.length);
    if (testList.length === 0) {
      return;
    }
    if (listDta.total_page === pageIndex) {
      return;
    }
    if (listDta.total_size <= testList.length) {
      return;
    }
    setPageIndex(prevState => prevState + 1);
  };
  useEffect(() => {
    console.log('pageIndex', pageIndex);
    if (updateBasicInfoObjState) {
      return;
    }
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);
  // useEffect(() => {
  //   if (currentYear === 0) {
  //     return;
  //   }
  //   console.log(currentYear, '1');
  //   setPageIndex(1);
  //   getList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentYear]);
  useEffect(() => {
    if (updateBasicInfoObjState) {
      return;
    }
    // @ts-ignore
    TestListRef.current?.scrollToTop();
    if (pageIndex !== 1) {
      console.log(TestListRef.current);
      setPageIndex(1);
      return;
    }
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [area, currentSecneType, currentYear]);
  const toggleOverlay = () => {
    setVisible(!visible);
    // StatusBar.setHidden(true);
  };
  const handleButtonPress = (
    title: string,
    basicInfo: {grade_id: number; term: string; version_id: number},
  ) => {
    // setBasicInfoName(title);
    dispatch(fetchSubjects(basicInfo.grade_id));
    setVisible(false);
    updatePreferences({
      grade_id: basicInfo.grade_id,
      term: basicInfo.term,
      subject_id: currentSubjectId,
      version_id: basicInfo.version_id,
    });
  };
  // 更新偏好设置
  const updatePreferences = async (data: UpdateXkwInfoParams) => {
    try {
      const res = await updateXkwInfo(data);
      if (res.status === 200) {
        setBasicInfoObj({
          subject_id: currentSubjectId,
          grade_id: res.data.xkwGradeId,
          term: res.data.xkwTerm,
          version_id: data.version_id,
        });
        setSenceType([
          {name: '全部', id: 'all'},
          ...zhuanti.type[
            res.data.xkwStageId ? res.data.xkwStageId : res.data.studyPhase
          ],
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 根据用户的信息获取树状结构
  useEffect(() => {
    setPageIndex(1);
    console.log('basicInfoObjChange', basicInfoObj);
    // if (updateBasicInfoObjState) {
    //   return;
    // }
    if (!basicInfoObj.subject_id) {
      return;
    }
    getList();
    const gradeName = grades.find(
      item => item.id === basicInfoObj.grade_id,
    )?.name;
    const termName = basicInfoObj.term === 'LAST' ? '上学期' : '下学期';
    const version = versions.find(i => i.id === basicInfoObj.version_id);
    const versionName = version ? version.name : versions[0].name;
    console.log(
      'setBasicInfoName',
      `${versionName}    |   ${gradeName} ${termName}`,
    );
    setBasicInfoName(`${versionName}    |   ${gradeName} ${termName}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicInfoObj]);
  //  切换学科修改年级版本
  useEffect(() => {
    console.log(currentSubjectId);
    if (basicInfoObj.grade_id != null) {
      getVersionId(basicInfoObj.grade_id, currentSubjectId).then(res => {
        setBasicInfoObj(prevState => {
          return {
            ...prevState,
            version_id: res,
            subject_id: currentSubjectId,
          };
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSubjectId]); // 当前科目或类型发生改变时触发;
  // 提交试卷
  const submitPaper = async (item: PapersForPhaseTestingResItem) => {
    console.log(item);
    showGlobalLoading({text: '加载中'});
    try {
      const p: {paperId: string} = {
        paperId: item.id,
      };
      const params: GetPaperDetailParams = {
        paper_id: item.id,
        moduleType: 'enrolmentPapers',
        sceneType: currentSecneType,
        subject_id: currentSubjectId,
        grade_id: basicInfoObj.grade_id,
        catalog_ids: [],
        formula_pic_format: '',
      };
      dispatch(fetchPaperPreview(p))
        .unwrap()
        .then(res => {
          if (res) {
            console.log(111, res);
            // @ts-ignore
            navigation.navigate('PaperPreview', params);
          }
        });
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  return (
    <>
      <View style={styles.ViewBox}>
        <SubjectList
          subjects={subjects}
          changeSubject={changeSubject}
          currentSubjectId={currentSubjectId}
        />
        <View style={styles.ViewBoxCon}>
          <BasicInfo
            basicInfoName={basicInfoName}
            basicInfoObj={basicInfoObj}
            userInfo={userInfo}
            currentSubjectId={currentSubjectId}
            visible={visible}
            handleButtonPress={handleButtonPress}
            toggleOverlay={toggleOverlay}
          />
          <View style={styles.ViewBoxMain}>
            <View style={styles.ViewBoxMainLeft}>
              <Buttons
                BtnList={senceType}
                currentSenceType={currentSecneType}
                setCurrentSenceType={setCurrentSecneType}
              />
            </View>
            <View style={styles.ViewBoxMainRight}>
              <View
                style={[
                  styles.ViewBoxMainRightBox,
                  {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  },
                ]}>
                <View style={[{flexDirection: 'row', alignItems: 'center'}]}>
                  <TouchableOpacity
                    onPress={() => {
                      setYearListVisible(true);
                    }}
                    style={styles.ViewBoxMainRightTop}>
                    <Text style={styles.ViewBoxMainRightTopText}>
                      {currentYear === 9999 || !currentYear
                        ? '年份'
                        : currentYear + '年'}
                    </Text>
                    <Image
                      style={styles.ViewBoxMainRightTopIcon}
                      source={{
                        uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/mylearn/bk/mylearn_beikai_bottomjt_.png',
                      }}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      setAreaListVisible(true);
                    }}
                    style={styles.ViewBoxMainRightTop}>
                    <Text style={styles.ViewBoxMainRightTopText}>
                      {area === 1
                        ? '地区'
                        : provinceList.find(item => item.id === area)?.name}
                    </Text>
                    <Image
                      style={styles.ViewBoxMainRightTopIcon}
                      source={{
                        uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/mylearn/bk/mylearn_beikai_bottomjt_.png',
                      }}
                    />
                  </TouchableOpacity>
                </View>

                <View
                  style={[
                    styles.ViewBoxMainRightTopInputBox,
                    {
                      flexDirection: 'row',
                      alignItems: 'center',
                    },
                  ]}>
                  <TextInput
                    style={styles.ViewBoxMainRightTopInput}
                    placeholder="请输入试卷关键字搜索"
                    placeholderTextColor={'#96959E'}
                    disableFullscreenUI={true}
                    returnKeyType={'search'}
                    value={searchValue}
                    onChangeText={text => setSearchValue(text)}
                    onSubmitEditing={async () => {
                      await getList();
                    }}
                  />
                  {searchValue !== '' && (
                    <TouchableOpacity
                      onPress={async () => {
                        setSearchValue('');
                        await getList(true);
                      }}>
                      <Image
                        style={styles.ViewBoxMainRightTopInputRightTextIcon}
                        source={{
                          uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/mylearn/bk/mylearn_beikai_mingxiao_clearn.png',
                        }}
                      />
                    </TouchableOpacity>
                  )}
                  <Text
                    style={[
                      styles.ViewBoxMainRightTopInputSearchEmpty,
                      {color: '#96959E'},
                    ]}>
                    |
                  </Text>
                  <TouchableOpacity
                    onPress={async () => {
                      await getList();
                    }}>
                    <Image
                      style={styles.ViewBoxMainRightTopInputSearch}
                      source={{
                        uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/mylearn/bk/mylearn_beikai_mingxiao_search_.png',
                      }}
                    />
                  </TouchableOpacity>
                </View>

                <YearListModal
                  onBackdropPress={() => {
                    setYearListVisible(false);
                  }}
                  year={currentYear}
                  changeYear={changeYear}
                  visible={yearListVisible}
                />
                <AreaListModal
                  onBackdropPress={() => {
                    setAreaListVisible(false);
                  }}
                  area={area}
                  areaList={areaList}
                  changeArea={changeArea}
                  visible={areaListVisible}
                />
              </View>
              <View style={styles.ViewBoxMainRightList}>
                <TestList
                  ref={TestListRef}
                  testList={testList}
                  loadMore={loadMore}
                  submitPaper={submitPaper}
                  footer={() => {
                    return (
                      <>
                        {testList.length !== 0 &&
                          (testList.length >= listDta.total_size ||
                            pageIndex === listDta.total_page) && (
                            <View
                              style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}>
                              <Text style={{color: '#999'}}>
                                {' '}
                                -- 没有更多了 --{' '}
                              </Text>
                            </View>
                          )}
                      </>
                    );
                  }}
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};
const styles = createStyles({
  ViewBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingHorizontal: '2.3rem',
    paddingBottom: '2.3rem',
  },
  ViewBoxCon: {
    flex: 1,
    marginTop: '1.8rem',
  },
  ViewBoxMain: {
    flex: 1,
    // marginTop: '0.85rem',
    flexDirection: 'row',
  },
  ViewBoxMainLeft: {
    width: '10.7rem',
  },
  ViewBoxMainRight: {
    flex: 1,
    backgroundColor: '#fff',
    marginLeft: '1.55rem',
    borderRadius: '1rem',
    paddingHorizontal: '2rem',
    paddingBottom: '2rem',
  },
  ViewBoxMainRightBox: {
    marginTop: '1.4rem',
  },
  ViewBoxMainRightTop: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '3.3rem',
  },
  ViewBoxMainRightTopText: {
    fontSize: '1.4rem',
    color: '#3d3d3d',
    fontWeight: '500',
    marginLeft: '0.5rem',
    marginRight: '1.95rem',
  },
  ViewBoxMainRightTopIcon: {
    width: '1.25rem',
    height: '1.25rem',
  },
  ViewBoxMainRightTopInputBox: {
    width: '26rem',
    height: '2.8rem',
    borderRadius: '0.75rem',
    backgroundColor: '#F4F7FF',
    paddingHorizontal: '0.9rem',
  },
  ViewBoxMainRightTopInputRight: {
    backgroundColor: '#fff',
    paddingHorizontal: '0.65rem',
    height: '2.2rem',
    borderRadius: '0.55rem',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ViewBoxMainRightTopInputRightText: {
    fontSize: '1.1rem',
    color: '#96959E',
  },
  ViewBoxMainRightTopInputRightTextIcon: {
    marginLeft: '0.8rem',
    width: '1.3rem',
    height: '1.3rem',
  },
  ViewBoxMainRightTopInput: {
    flex: 1,
    fontSize: '1rem',
    color: '#96959E',
    padding: 0,
    margin: 0,
  },
  ViewBoxMainRightTopInputSearch: {
    width: '1.5rem',
    height: '1.5rem',
  },
  ViewBoxMainRightTopInputSearchEmpty: {
    color: '#96959E',
    marginHorizontal: '0.8rem',
  },
  ViewBoxMainRightList: {
    flex: 1,
    marginTop: '1.2rem',
    backgroundColor: '#F4F7FF',
    borderRadius: '1rem',
    padding: '1.4rem',
  },
});
export default MyLearnBeikaoZhuanti;
